import React from 'react';

const Button = ({
  icon: Icon,
  loading = false,
  ghost = false,
  link = false,
  disabled = false,
  shape = 'default',
  htmlType = 'button',
  type = 'default',
  onClick,
  className = '',
  children
}) => {
  const hasSlot = !!children;
  
  const classes = [
    'flex flex-row justify-center items-center gap-x-1',
    link ? '' : hasSlot ? 'px-3 py-1' : 'px-1 py-1',
    shape === 'round' ? 'rounded-full' : shape === 'coupon' ? 'rounded-lg rounded-br-[0.875rem]' : 'rounded-button',
    disabled ? 'cursor-not-allowed' : 'cursor-pointer',
    ghost ? 'border' : '',
    ghost || link ? 'bg-transparent' :
    disabled ? (type === 'default' ? 'text-secondary-text-disabled border-secondary-border' :
                type === 'primary' ? 'text-secondary-text-invert bg-overlay backdrop-blur-xl' :
                'text-secondary-text-invert bg-secondary-text-disabled') :
    type === 'primary' ? 'bg-primary hover:bg-primary-hover text-secondary-text' :
    type === 'success' ? 'bg-success hover:bg-success-hover text-secondary-text-invert' :
    type === 'info' ? 'bg-info hover:bg-info-hover text-secondary-text-invert' :
    type === 'danger' ? 'bg-red-600 hover:bg-red-900 text-secondary-text-invert' :
    type === 'warning' ? 'bg-warning hover:bg-warning-hover text-secondary-text-invert' :
    'bg-secondary-background-gray text-secondary-text',
    (ghost || link) ?
    disabled ? (type === 'primary' ? 'text-secondary-text-invert' : 'text-secondary-text-disabled border-secondary-border') :
    type === 'primary' ? 'border-primary text-primary hover:border-primary-hover hover:text-primary-hover' :
    type === 'success' ? 'border-success text-success hover:border-success-hover hover:text-success-hover' :
    type === 'info' ? 'border-info text-info hover:border-info-hover hover:text-info-hover' :
    type === 'danger' ? 'border-danger text-danger hover:border-danger-hover hover:text-danger-hover' :
    type === 'warning' ? 'border-warning text-warning hover:border-warning-hover hover:text-warning-hover' :
    'border-secondary-border text-secondary-text hover:border-primary-hover hover:text-primary-hover' : '',
    className
  ].join(' ');

  return (
    <button type={htmlType} className={classes} onClick={!disabled ? onClick : undefined} disabled={disabled}>
      {Icon && !loading && <div className="w-5 h-5 flex items-center justify-center"><Icon /></div>}
      {loading && <div className="w-5 h-5">Loading...</div>}
      {hasSlot && <div className={`w-full ${link && !disabled ? 'hover:underline' : ''}`}>{children}</div>}
    </button>
  );
};

export default Button;